export const ALL_PERMISSION_SLUGS = [
  'admin.dashboard',
  'admin.users.view',
  'admin.users.edit',
  'admin.galleries.view',
  'admin.galleries.moderate',
  'admin.reviews.moderate',
  'admin.orders.view',
  'admin.settings.edit',
  'galleries.view',
  'galleries.create',
  'galleries.edit',
  'galleries.delete',
  'galleries.publish',
  'photos.view',
  'photos.upload',
  'photos.edit',
  'photos.delete',
  'cart.view',
  'cart.add',
  'cart.remove',
  'cart.checkout',
  'purchases.view',
  'purchases.download',
  'reviews.create',
  'reviews.edit',
  'reviews.delete',
  'profile.view',
  'profile.edit',
  'galleries.create.own',
  'galleries.create.all',
  'galleries.view.own',
  'galleries.view.all',
  'galleries.edit.own',
  'galleries.edit.all',
  'galleries.delete.own',
  'galleries.delete.all',
  'galleries.publish.own',
  'galleries.publish.all',
  'galleries.collaborators.manage.own',
  'galleries.collaborators.manage.all',
  'photos.upload.own',
  'photos.upload.all',
  'photos.edit.own',
  'photos.edit.all',
  'photos.delete.own',
  'photos.delete.all',
  'videos.upload.own',
  'videos.upload.all',
  'videos.publish.own',
  'videos.publish.all',
  'videos.delete.own',
  'videos.delete.all',
  'products.images.create.own',
  'products.images.create.all',
  'products.images.edit.own',
  'products.images.edit.all',
  'products.images.delete.own',
  'products.images.delete.all',
  'orders.view.own',
  'orders.view.all',
  'promotions.view.own',
  'promotions.view.all',
  'promotions.create.own',
  'promotions.create.all',
  'promotions.edit.own',
  'promotions.edit.all',
  'promotions.delete.own',
  'promotions.delete.all',
  'reviews.view.own',
  'reviews.view.all',
  'reviews.respond.own',
  'reviews.respond.all',
  'admin.categories.view',
  'admin.categories.create',
  'admin.categories.edit',
  'admin.categories.delete',
  'admin.orders.edit',
  'admin.settings.view',
  'admin.profiles.view',
  'admin.profiles.create',
  'admin.profiles.edit',
  'admin.profiles.delete',
  'admin.profiles.assign',
  'admin.reviews.approve',
  'admin.reviews.delete',
  'admin.promotions.usages',
  'admin.promotions.suspend-fraud',
  'admin.promotions.resolve-fraud',
  'admin.galleries.create',
  'admin.galleries.edit',
  'admin.galleries.delete',
  'admin.galleries.watermarks.regenerate',
  'admin.users.delete',
  'admin.roles.view',
  'admin.roles.create',
  'admin.roles.edit',
  'admin.roles.delete',
  'admin.permissions.view',
  'admin.redirects.view',
  'admin.redirects.create',
  'admin.redirects.edit',
  'admin.redirects.delete',
  'admin.activity-logs.view',
  'admin.media.monitor',
  'admin.media.reprocess',
  'admin.galleries.watermarks.manage',
  'admin.profiles.watermark.manage',
] as const;

export type PermissionSlug = (typeof ALL_PERMISSION_SLUGS)[number];

export const PERMISSIONS = {
  ADMIN: {
    DASHBOARD: 'admin.dashboard',
    USERS: {
      VIEW: 'admin.users.view',
      EDIT: 'admin.users.edit',
      DELETE: 'admin.users.delete',
    },
    GALLERIES: {
      VIEW: 'admin.galleries.view',
      MODERATE: 'admin.galleries.moderate',
      CREATE: 'admin.galleries.create',
      EDIT: 'admin.galleries.edit',
      DELETE: 'admin.galleries.delete',
      WATERMARKS_REGENERATE: 'admin.galleries.watermarks.regenerate',
      WATERMARKS_MANAGE: 'admin.galleries.watermarks.manage',
    },
    REVIEWS: {
      MODERATE: 'admin.reviews.moderate',
      APPROVE: 'admin.reviews.approve',
      DELETE: 'admin.reviews.delete',
    },
    ORDERS: {
      VIEW: 'admin.orders.view',
      EDIT: 'admin.orders.edit',
    },
    SETTINGS: {
      VIEW: 'admin.settings.view',
      EDIT: 'admin.settings.edit',
    },
    CATEGORIES: {
      VIEW: 'admin.categories.view',
      CREATE: 'admin.categories.create',
      EDIT: 'admin.categories.edit',
      DELETE: 'admin.categories.delete',
    },
    PROFILES: {
      VIEW: 'admin.profiles.view',
      CREATE: 'admin.profiles.create',
      EDIT: 'admin.profiles.edit',
      DELETE: 'admin.profiles.delete',
      ASSIGN: 'admin.profiles.assign',
      WATERMARK_MANAGE: 'admin.profiles.watermark.manage',
    },
    PROMOTIONS: {
      USAGES: 'admin.promotions.usages',
      SUSPEND_FRAUD: 'admin.promotions.suspend-fraud',
      RESOLVE_FRAUD: 'admin.promotions.resolve-fraud',
    },
    ROLES: {
      VIEW: 'admin.roles.view',
      CREATE: 'admin.roles.create',
      EDIT: 'admin.roles.edit',
      DELETE: 'admin.roles.delete',
    },
    PERMISSIONS: {
      VIEW: 'admin.permissions.view',
    },
    REDIRECTS: {
      VIEW: 'admin.redirects.view',
      CREATE: 'admin.redirects.create',
      EDIT: 'admin.redirects.edit',
      DELETE: 'admin.redirects.delete',
    },
    ACTIVITY_LOGS: {
      VIEW: 'admin.activity-logs.view',
    },
    MEDIA: {
      MONITOR: 'admin.media.monitor',
      REPROCESS: 'admin.media.reprocess',
    },
  },
  GALLERIES: {
    VIEW: 'galleries.view',
    CREATE: 'galleries.create',
    EDIT: 'galleries.edit',
    DELETE: 'galleries.delete',
    PUBLISH: 'galleries.publish',
    CREATE_OWN: 'galleries.create.own',
    CREATE_ALL: 'galleries.create.all',
    VIEW_OWN: 'galleries.view.own',
    VIEW_ALL: 'galleries.view.all',
    EDIT_OWN: 'galleries.edit.own',
    EDIT_ALL: 'galleries.edit.all',
    DELETE_OWN: 'galleries.delete.own',
    DELETE_ALL: 'galleries.delete.all',
    PUBLISH_OWN: 'galleries.publish.own',
    PUBLISH_ALL: 'galleries.publish.all',
    COLLABORATORS_MANAGE_OWN: 'galleries.collaborators.manage.own',
    COLLABORATORS_MANAGE_ALL: 'galleries.collaborators.manage.all',
  },
  PHOTOS: {
    VIEW: 'photos.view',
    UPLOAD: 'photos.upload',
    EDIT: 'photos.edit',
    DELETE: 'photos.delete',
    UPLOAD_OWN: 'photos.upload.own',
    UPLOAD_ALL: 'photos.upload.all',
    EDIT_OWN: 'photos.edit.own',
    EDIT_ALL: 'photos.edit.all',
    DELETE_OWN: 'photos.delete.own',
    DELETE_ALL: 'photos.delete.all',
  },
  VIDEOS: {
    UPLOAD_OWN: 'videos.upload.own',
    UPLOAD_ALL: 'videos.upload.all',
    PUBLISH_OWN: 'videos.publish.own',
    PUBLISH_ALL: 'videos.publish.all',
    DELETE_OWN: 'videos.delete.own',
    DELETE_ALL: 'videos.delete.all',
  },
  PRODUCTS: {
    IMAGES_CREATE_OWN: 'products.images.create.own',
    IMAGES_CREATE_ALL: 'products.images.create.all',
    IMAGES_EDIT_OWN: 'products.images.edit.own',
    IMAGES_EDIT_ALL: 'products.images.edit.all',
    IMAGES_DELETE_OWN: 'products.images.delete.own',
    IMAGES_DELETE_ALL: 'products.images.delete.all',
  },
  CART: {
    VIEW: 'cart.view',
    ADD: 'cart.add',
    REMOVE: 'cart.remove',
    CHECKOUT: 'cart.checkout',
  },
  PURCHASES: {
    VIEW: 'purchases.view',
    DOWNLOAD: 'purchases.download',
  },
  REVIEWS: {
    CREATE: 'reviews.create',
    EDIT: 'reviews.edit',
    DELETE: 'reviews.delete',
    VIEW_OWN: 'reviews.view.own',
    VIEW_ALL: 'reviews.view.all',
    RESPOND_OWN: 'reviews.respond.own',
    RESPOND_ALL: 'reviews.respond.all',
  },
  PROFILE: {
    VIEW: 'profile.view',
    EDIT: 'profile.edit',
  },
  ORDERS: {
    VIEW_OWN: 'orders.view.own',
    VIEW_ALL: 'orders.view.all',
  },
  PROMOTIONS: {
    VIEW_OWN: 'promotions.view.own',
    VIEW_ALL: 'promotions.view.all',
    CREATE_OWN: 'promotions.create.own',
    CREATE_ALL: 'promotions.create.all',
    EDIT_OWN: 'promotions.edit.own',
    EDIT_ALL: 'promotions.edit.all',
    DELETE_OWN: 'promotions.delete.own',
    DELETE_ALL: 'promotions.delete.all',
  },
} as const satisfies Record<string, unknown>;
